export default {
  BASE_URL: '',
  api: [
    {
      name: 'list',
      method: 'GET',
      desc: '获取品牌列表',
      path: '/mm/brand/show/List',
      params: {
        pageSize: 25,
        pageNum: 1,
        brandName: '',
        category: '1;2'
      }
    },
    {
      name: 'changeState',
      method: 'POST',
      desc: '启用/禁用品牌',
      path: '/mm/brand/operateStatus',
      params: {
        id: '',
        isEnable: false
      }
    },
    {
      name: 'delete',
      method: 'GET',
      desc: '删除品牌',
      path: '/mm/brand/removeBrand',
      append: true,
      params: {
        id: ''
      }
    },
    {
      name: 'detail',
      method: 'GET',
      desc: '品牌详情',
      path: '/mm/brand/currentBrand/{id}',
      params: {
        id: ''
      }
    },
    {
      name: 'checkName',
      method: 'GET',
      desc: '校验品牌中英文名称',
      path: '/mm/brand/validate/name',
      params: {
        englishName: '',
        brandName: ''
      }
    },
    {
      name: 'selectNextSortNum',
      method: 'GET',
      desc: '获取下个品牌的排序号及编号',
      path: '/mm/brand/next/brand'
    },
    {
      name: 'save',
      method: 'POST',
      desc: '保存品牌',
      path: '/mm/brand/operate',
      params: {
        brandName: '',
        englishName: '',
        descript: '',
        sortNum: '',
        isEnable: '',
        origin: '',
        image: [],
        category: ''
      }
    },
    /* 品牌管理 */
    {
      name: 'current',
      method: 'GET',
      desc: '品牌详情',
      path: '/crm/brand/current'
    },
    {
      name: 'brandList',
      method: 'GET',
      desc: '品牌列表',
      path: '/crm/brand/show/List'
    },
    {
      name: 'audit',
      method: 'POST',
      desc: '品牌审核',
      path: '/crm/brand/audit'
    },
    {
      name: 'valid',
      method: 'GET',
      desc: '校验品牌名称',
      path: '/crm/brand/valid'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/pm/brand.js